import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';
import HelpItems from '../HelpItems/HelpItems';
import type { SettingsHubHelpItem } from '../../modules/configuration-settings/models';

export interface PageHeaderProps {
  title: string;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
  helpItems?: SettingsHubHelpItem[];
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  icon,
  actions,
  helpItems,
  className,
}) => {
  const { colors } = useTheme();

  return (
    <div className={cn('mb-6 rounded-xl border px-4 py-4 sm:px-5', colors.border, colors.surface, className)}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0 flex-1">
          <div className="flex items-start gap-3">
            {icon ? (
              <span className={cn('mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg', colors.headerBg, colors.primaryFg)}>
                {icon}
              </span>
            ) : null}
            <div className="min-w-0">
              <h2 className={cn('text-base font-semibold tracking-tight', colors.text)}>{title}</h2>
              {description ? (
                <p className={cn('mt-1 text-sm leading-relaxed', colors.textMuted)}>{description}</p>
              ) : null}
            </div>
          </div>
          <HelpItems items={helpItems} className={title || description ? 'mt-2' : undefined} />
        </div>
        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </div>
    </div>
  );
};

export default PageHeader;
